(function () {
    'use strict';

    angular.module("imApp").factory("productCompositionService", ['$ihttp', function ($ihttp) {
        let service = {
            getProductComposition: function (parms) {
                return $ihttp.post({
                    method: 2705,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2707,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
